/**
 * Entrega o arquivo ao navegador com o nome original: uma URL temporária, um `<a download>`
 * que só existe durante o clique e a revogação logo depois — no próximo ciclo, porque há
 * navegador que ainda lê a URL depois de o `click()` retornar.
 *
 * É o download de todo arquivo que chega como `blob` por rota com token ou com protocolo: um
 * `<a href>` direto não levaria o cabeçalho de autorização.
 */
export function salvarArquivo(arquivo: Blob, nome: string): void {
  const url = URL.createObjectURL(arquivo);
  const link = document.createElement('a');

  link.href = url;
  link.download = nome;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url));
}
